import type { Store } from "redux";
import type { RootAction } from "typesafe-actions";
import { sendMessageToWorkspace } from "./post-message-dispatch";
import { ManageBrowserHistory } from "./services/dependencies/manageBrowserHistory";
import type { AppState } from "./state/root.reducer";
import {
  editWorkspace,
  showDashboard,
} from "./state/workspaces/workspaces.actions";

type WorkspaceWithSearchParams = {
  workspaceId: string;
  urlSearchParams: URLSearchParams;
};

function getWorkspaceIdWithUrlSearchParams(
  path: string,
): WorkspaceWithSearchParams {
  if (!path.includes("?"))
    return { workspaceId: path, urlSearchParams: new URLSearchParams("") };

  const dividedPath = path.split("?");
  return {
    workspaceId: dividedPath[0],
    urlSearchParams: new URLSearchParams(dividedPath[1]),
  };
}

function historyStateToAction(
  state: string,
  appMode: string,
): RootAction | undefined {
  if (state === "DASHBOARD") return showDashboard();
  if (state) {
    if (appMode === "EDITING") return undefined;

    const { workspaceId, urlSearchParams } =
      getWorkspaceIdWithUrlSearchParams(state);
    return editWorkspace({
      workspaceId,
      urlSearchParams,
    });
  }
  // Note: this only happens in a strange case in Safari, when doing something in pendo portal (feedback) after closing pendo portal and then navigating to dashboard
  return undefined;
}

export function connectHistoryToDispatch(store: Store<AppState>) {
  ManageBrowserHistory.replaceState("/", "DASHBOARD");

  window.addEventListener("popstate", (event) => {
    const state = store.getState();
    const actionSec = historyStateToAction(event.state, state.mode);

    if (event.state !== "DASHBOARD") {
      const { workspaceId, urlSearchParams } =
        getWorkspaceIdWithUrlSearchParams(event.state);
      const searchParams = urlSearchParams.toString();
      if (searchParams.length) {
        sendMessageToWorkspace(workspaceId, {
          action: "NAVIGATE_TO_ITEM",
          searchParams,
        });
      }
    }

    if (actionSec) {
      store.dispatch(actionSec);
    }
  });
}
